'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('@emotion/react');
require('aviary-tokens');
require('../../internal/InternalSkeleton/InternalSkeleton.web.styles.cjs');
require('../Typography/Typography.web.cjs');
var InternalButtonLink_web = require('../../internal/InternalButtonLink/InternalButtonLink.web.cjs');

/**
 * A button component without default browser styles used as a trigger to perform a specific action
 *
 * {@link https://aviary.supernova-docs.io/latest/components/no-style-button-short-pressable/overview-42kNgJaC | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/NoStyleButton/NoStyleButton.web.tsx | View in GitLab}
 *
 * @scope Core (ShortPressable in native)
 */ const NoStyleButton = ({ customCss, ...props })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(InternalButtonLink_web.InternalButtonLink, {
        css: customCss,
        ...props
    });
};

exports.NoStyleButton = NoStyleButton;
//# sourceMappingURL=NoStyleButton.web.cjs.map
